import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import objectPrototypeAccessorsForced from '../internals/object-prototype-accessors-forced.js';
import aCallable$1 from '../internals/a-callable.js';
import toObject$1 from '../internals/to-object.js';
import '../internals/object-define-property.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var FORCED = objectPrototypeAccessorsForced;
var aCallable = aCallable$1;
var toObject = toObject$1;
var definePropertyModule = objectDefineProperty; // `Object.prototype.__defineSetter__` method
// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__

if (DESCRIPTORS) {
  $({
    target: 'Object',
    proto: true,
    forced: FORCED
  }, {
    __defineSetter__: function __defineSetter__(P, setter) {
      definePropertyModule.f(toObject(this), P, {
        set: aCallable(setter),
        enumerable: true,
        configurable: true
      });
    }
  });
}
